import React from 'react'
import {Button} from "react-bootstrap";
import crypto from "crypto";
import {authConfigs} from "../utils/constant";

const base64URLEncode = (str) => {
    return str.toString('base64')
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '');
}

const createSHA256 = (buffer) => {
    return crypto.createHash('sha256')
        .update(buffer)
        .digest();
}

const LinkToAuthorizeLogin = (props) => {

    const gotoProcess = async () => {
        const authUrl = process.env.REACT_APP_OAUTH_URL + process.env.REACT_APP_OAUTH_PATH_AUTHORIZE
        const client_id = process.env.REACT_APP_OAUTH_CLIENT_ID;
        const redirect_uri = process.env.REACT_APP_OAUTH_BASE_URL + process.env.REACT_APP_OAUTH_URL_CALLBACK;
        const code_challenge_method = 'S256';
        const code_verifier = base64URLEncode(crypto.randomBytes(64));
        const code_challenge = base64URLEncode(createSHA256(code_verifier));
        localStorage.setItem('code_verifier', code_verifier)

        const authorizUrl = `${authUrl}?response_type=${authConfigs.response_type}&scope=${authConfigs.scope}&client_id=${client_id}&redirect_uri=${redirect_uri}&code_challenge_method=${code_challenge_method}&code_challenge=${code_challenge}`
        window.location.href = (authorizUrl)
    }

    return <Button
        variant="success"
        block
        style={{marginTop: 20}}
        onClick={() => gotoProcess()}
    >
        KU ALL-Login
    </Button>

}

export default LinkToAuthorizeLogin